module.exports = __webpack_public_path__ + "static/media/newsletter-march-2019-blessing.36edade0.jpg";